export default {
  icons: {
    iconfont: 'fa'
  },
  rtl: false,
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#428eff',
        secondary: '#101010',
        accent: '#82B1FF',
        error: '#ff3b5e',
        info: '#101010',
        success: '#00ad60',
        warning: '#ffab2e'
      }
    }
  }
}
